import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import { Typography, Box } from "@material-ui/core";
import { OverlayCircularProgress } from "@ploy-ui/core";
import BuyoutBreadcrumbs from "../BuyoutBreadcrumbs";
import useBuyoutStyles from "../../BuyoutStyles";
import { useIntl } from "react-intl";
import { messages } from "../../messages";
import EmailSlidein from "./Overlays/Email/EmailSlidein";
import { useParams } from "react-router-dom";
import ContractInfoCard from "./ContractInfoCard";
import DetailsTable from "./DetailsTable";
import BuyoutSection from "./BuyoutSection";
import { formatApplicationNumber } from "../../utils/formatApplicationNumber";
import { fetchApplication } from "../../endpoints/CoreBuyout";
export function SpecificCoreBuyout() {
    const classes = useBuyoutStyles();
    const [showEmailSlidein, setShowEmailSlidein] = useState(false);
    const [availableForAutomaticBuyoutPrice, setAvailableForAutomaticBuyoutPrice] = useState(true);
    const [application, setApplication] = useState(null);
    const [error, setError] = useState(null);
    const [loaded, setLoaded] = useState(false);
    const [paymentInfo, setPaymentInfo] = useState(null);
    const params = useParams();
    const applicationNumber = params.applicationNumber;
    const intl = useIntl();
    const getData = React.useCallback(() => {
        if (!applicationNumber)
            return;
        setLoaded(false);
        setError(null);
        fetchApplication(applicationNumber)
            .then(appData => {
            setApplication(appData);
            setAvailableForAutomaticBuyoutPrice(!appData.BuyoutBlocked);
        })
            .catch((err) => {
            if (err?.status === 403) {
                setError(intl.formatMessage(messages.noPermissionView));
            }
            else {
                setError(intl.formatMessage(messages.loadError));
            }
            setApplication(null);
        })
            .finally(() => setLoaded(true));
    }, [applicationNumber, intl]);
    useEffect(() => {
        getData();
    }, [getData]);
    if (!loaded) {
        return _jsx(OverlayCircularProgress, { pending: !loaded });
    }
    if (error) {
        return (_jsx(Box, { m: 4, children: _jsx(Typography, { color: "error", variant: "body1", children: error }) }));
    }
    return (_jsxs(Box, { className: classes.container, children: [_jsx(BuyoutBreadcrumbs, { applicationNumber: applicationNumber, application: application, includeContract: true }), _jsx(Typography, { className: classes.title, children: intl.formatMessage(messages.contractPageTitle, {
                    number: formatApplicationNumber(application?.AccountNumber)
                }) }), _jsxs(Box, { className: classes.contractRow, children: [_jsx(ContractInfoCard, { application: application, classes: classes }), _jsxs(Box, { className: classes.rightSection, children: [_jsx(DetailsTable, { application: application, classes: classes }), _jsx(BuyoutSection, { availableForAutomaticBuyoutPrice: availableForAutomaticBuyoutPrice, classes: classes, paymentInfo: paymentInfo, setPaymentInfo: setPaymentInfo, applicationNumber: applicationNumber, application: application, setShowEmailSlidein: setShowEmailSlidein })] })] }), applicationNumber && (_jsx(EmailSlidein, { open: showEmailSlidein, onClose: () => setShowEmailSlidein(false), applicationNumber: applicationNumber, paymentInfo: paymentInfo }))] }));
}
//# sourceMappingURL=SpecificCoreBuyout.js.map